import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />

        <footer>
          Whis project was coded by{" "}
          <a
            href="https://github.com/Airini2001"
            target="_blank"
            rel="noopener noreferrer"
          >
            Irina Mitrofanova {""}
          </a>
          {""}
          and is{" "}
          <a
            href="https://github.com/Airini2001/React-Weather-App"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>
          {" "} and {" "}
          <a
            href="https://fanciful-truffle-717708.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}

